import React from 'preact';
import { useEffect } from "preact/compat";
import { useState } from "preact/hooks";
import constants from '../../constants';

interface OneColumnProps {
  active: boolean;
}

export default function OneColumn({ active }: OneColumnProps) {
  const [primaryColor, setPrimaryColor] = useState('');

  useEffect(() => {
    if (active) {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
    } else {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_INACTIVE);
    }
  }, [active]);

  return (
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path fill={primaryColor} d="M19.689 5.581H.311c-.167 0-.311.076-.311.18v1.232c0 .094.144.179.311.179h19.378c.167 0 .311-.076.311-.18V5.76c0-.094-.144-.179-.311-.179zM19.689.905H.311C.144.905 0 .98 0 1.084v1.232c0 .095.144.18.311.18h19.378c.167 0 .311-.076.311-.18V1.084c0-.094-.144-.179-.311-.179zM19.689 14.934H.311c-.167 0-.311.075-.311.179v1.233c0 .094.144.178.311.178h19.378c.167 0 .311-.075.311-.178v-1.233c0-.094-.144-.179-.311-.179zM19.689 10.258H.311c-.167 0-.311.075-.311.179v1.232c0 .094.144.179.311.179h19.378c.167 0 .311-.075.311-.179v-1.232c0-.095-.144-.18-.311-.18z"/>
        </g>
    </svg>
  );
}